import React, { useState, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
// import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../config/config";
import { BusinessSettingsContext } from "../context/BusinessSettingsContext";

const Signin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(null);
    // const navigate = useNavigate();
    const { settings } = useContext(BusinessSettingsContext);
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess(null);
    
        try {
            const response = await axios.post(`${BASE_URL}/login`, { email, password });
    
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user)); // Store user details
                setSuccess('Login successful!');
                window.location.href = '/'; // Redirect after login
            }
        } catch (err) {
            setError('Invalid email or password');
        }
    };
    

    return (
        <main className="main">
            <div className="container-fluid">
                <div className="row row--grid">
                    <div className="col-12">
                        <div className="sign">
                            <div className="sign__content">
                                <form onSubmit={handleSubmit} className="sign__form">
                                    <a href="/" className="sign__logo">
                                        <img src={ settings.website_logo || "Website Name" } alt=''/>
                                    </a>

                                    {error && <div style={{ color: 'red' }}>{error}</div>}
                                    {success && <div style={{ color: 'green' }}>{success}</div>}

                                    <div className="sign__group">
                                        <input 
                                            type="text" 
                                            className="sign__input" 
                                            placeholder="Email" 
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="sign__group">
                                        <input 
                                            type="password" 
                                            className="sign__input" 
                                            placeholder="Password" 
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="sign__group sign__group--checkbox">
                                        <input id="remember" name="remember" type="checkbox" defaultChecked />
                                        <label htmlFor="remember">Remember Me</label>
                                    </div>
                                    
                                    <button className="sign__btn" type="submit">Sign in</button>

                                    <span className="sign__text">Don't have an account? <Link to="/register">Sign up!</Link></span>
                                    {/* <span className="sign__text"><a href="forgot.html">Forgot password?</a></span> */}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default Signin;
